

/**
 * Получение $ объекта следующего слайда, после прокрутки (того, который не виден)/
 * Для слайдов, где шаг = 1
 * Надо помнить, что слайдер может показывать несколько слайдов. А активный слайд всегда самый левый
 */

export const getNextSlide = (sliderContainerClass, activeIndex, moveDirection, slidesShow = 1) => {
    const allSlides = $(sliderContainerClass).find('.glide__slides').find('.glide__slide').not('.glide__slide--clone');

    const slidesCount = allSlides.length;

    let nextIndex = activeIndex + slidesShow;

    if (moveDirection === '<') {
        nextIndex = activeIndex - 1;
    }

    if (activeIndex + 1 === slidesCount && moveDirection === '>') {
        nextIndex = 0;
    }

    if (activeIndex === 0 && moveDirection === '<') {
        nextIndex = slidesCount - 1;
    }

    return $(allSlides.get(nextIndex));
}

// Выравинвание высоты слайда
export const adjustHeight = ($slide) => {
    const track = $slide.parents('.glide__track');
    const slideHeight = $slide.outerHeight();
    const glideTrack = track.outerHeight();

    if (slideHeight !== glideTrack) {
        track.css('height', slideHeight);
    }
}